import { forwardRef } from 'react';

type CanvasShellProps = {
	children: React.ReactNode;
	/** Optional floor for the canvas height in px. See Kitchen3dProps.canvasMinHeight. */
	minHeight?: number;
};

// No default floor: Render3DKitchen only mounts once Kitchen3d has measured a
// non-zero container, and a floor only distorted small preview boxes. A
// consumer that wants one still sets it through canvasMinHeight.
export const CanvasShell = forwardRef<HTMLDivElement, CanvasShellProps>(({ children, minHeight }, ref) => (
	<div
		ref={ref}
		style={{
			position: 'absolute',
			height: '100%',
			width: '100%',
			...(minHeight ? { minHeight: `${minHeight}px` } : {})
		}}
	>
		<div />
		{children}
	</div>
));

CanvasShell.displayName = 'CanvasShell';
